import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

/// images
import ic_warning_remove from "../../../images/ic_warning_remove.svg";
import ic_close_remove_popup from "../../../images/ic_close_remove_popup.svg";
/// data

/// components
import { closePopup } from "../../../redux/actions/popupAction/popupContainerAction";
// removeVisitor
//action
import { setActiveVisitor } from "../../../redux/actions/visitorAction/visitorAction";
import { REMOVE_VISITOR_STATUS_DISABLED_SUCCESS } from "../../../data/popupData";
import { openPopupNotification } from "../../../redux/actions/popupAction/popupNotificationAction";

const Bound = styled.div`
  padding: 32px 0px;
  width: 409px;
  height: 316px;
  box-sizing: border-box;
  border-radius: 16px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: bold;
  background: #fafafa;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
  /* animate */
  animation-name: isShowPopup;
  transition-property: bottom;
  transition-duration: 500ms;
  display: relative;
  @keyframes isShowPopup {
    from {
      top: -100px;
    }
    to {
      top: 45px;
    }
  }
  .ic-close-remove-popup {
    position: absolute;
    right: 22px;
    top: 22px;
    cursor: pointer;
  }
`;

const Content = styled.div`
  width: 100%;
  /* margin-top: 162px; */
  text-align: center;
  .ic-warning-remove {
  }
  .confirm-remove-title {
    margin: 12px 0 6px 0;
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    text-align: center;
    color: #262626;
    .block-device-remove {
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        :nth-child(1) {
          display: inline-block;
          font-weight: bold;
          color: #33ADFF;
        }
        :nth-child(2) {
          max-width: 200px;
          display: inline-block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: bold;
          margin-left: 5px;
        }
      }
    }
  }
  .confirm-remove-content {
    padding: 0 35px;
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: #000924;
  }
  .block-btn {
    margin-top: 24px;
    display: flex;
    justify-content: center;
    .remove-btn,
    .cancel-btn {
      width: 160px;
      height: 50px;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: Open Sans;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
      text-align: center;
      letter-spacing: 0.03em;
      cursor: pointer;
    }
    .remove-btn {
      background: #ea3939;
      color: #ffffff;
      margin-right: 12px;
    }
    .cancel-btn {
      color: #33adff;
      background: #ffffff;
      border: 0.572641px solid #33adff;
    }
  }
`;

const PopupDisableVistor = (props) => {
    const dispatch = useDispatch()

    const { data, TypePopup } = useSelector(state => ({
        TypePopup: state.popupContainerReducer.typePopup,
        data: state.popupContainerReducer.data
    }));
  //======================Function=================================

    const _onClosePopup = () => {
        dispatch(closePopup())
    };

    const _onConfirmRemove = () => {
        // console.log(data);        
        if(data){
          dispatch(setActiveVisitor(data.UserID, data.CompanyID, true ))          
          dispatch(openPopupNotification(
            REMOVE_VISITOR_STATUS_DISABLED_SUCCESS,
            {
              contentProps: data.Name
            },
            false,
          ))
        }
        dispatch(closePopup())
    }

  const _handleUserKeyPress = useCallback(event => {
    const { key, keyCode } = event;
    // console.log(key, keyCode)
    //  Escape 27
    //  Enter 13
    switch (keyCode) {
      case 27:
        _onClosePopup()
        break;
      case 13:
        _onConfirmRemove()
        break;
      default:
        break;
    }

  }, []);

  useEffect(() => {
    window.addEventListener("keydown", _handleUserKeyPress)
    return () => {
      window.removeEventListener("keydown", _handleUserKeyPress)
    }
  }, [_handleUserKeyPress])

    return (
    <Bound>
      <img
        className="ic-close-remove-popup"
        src={ic_close_remove_popup}
        onClick={_onClosePopup}
        alt="ic_close"
      />
      <Content>
        <img
          className="ic-warning-remove"
          src={ic_warning_remove}
          alt="ic_warning"
        />
        <div className="confirm-remove-title">
          <span>Are you sure you want to disable</span>
          <div className="block-device-remove">
            <span>{data.Name}</span>
          </div>
        </div>
        <p className="confirm-remove-content">
            This profile will be disabled immediatly. If you don't want to disable, please click cancel.{" "}
        </p>
        <div className="block-btn">
          <div className="remove-btn" onClick={_onConfirmRemove}>
            DISABLE
          </div>
          <div className="cancel-btn" onClick={_onClosePopup}>
            CANCEL
          </div>
        </div>
      </Content>
    </Bound>
  );
}

PopupDisableVistor.propTypes = {
  data: PropTypes.object
};

export default PopupDisableVistor;
